import React, { useEffect, useState } from 'react';
import BoxCollapse from 'components/_UI/BoxCollapse';
import InputWithAutocomplete from 'components/_UI/InputWithAutocomplete';
import eventsApi from 'api/requests/events'
import EventsNearToYou from '../nearToYou/EventsNearToYou';
import Selects from './Selects';
import breakpoints from 'theme/breakpoints';
import { useCollapse } from 'context/general/Collapse';
import EventDetail from '../detail/EventDetail';
import Button from 'components/_UI/Button';
import { useEvent } from 'context/events/Event';
import { useEventFilter } from 'context/events/EventFilter';
import styled from 'styled-components';
import { Column } from 'styled/alignment/Column';
import sizes from 'theme/sizes';
import colors from 'theme/colors';
import Text from 'components/_UI/Text';
import { Row } from 'styled/alignment/Row';
import Icon from 'components/_UI/Icon';

const INITIAL_HEIGHT = '300px';
const END_HEIGHT = '85vh';

const ARROW_UP = 'up';
const ARROW_DOWN = 'down';

let randomNumber = false

export default function BoxFilters({
    isRouteParam,
    userLocation,
    onClose,
    onDelete,
    onEdit,
    onNearToYouClick = false
}) {
    const { eventFilter, setEventFilter } = useEventFilter();

    useEffect(() => {
        setCollapse({
            ...collapse,
            arrowPosition: true,
            height: INITIAL_HEIGHT
        })

        if (isRouteParam) {
            upCollapse()
        }
    }, [userLocation, isRouteParam])

    const { collapse, setCollapse } = useCollapse();
    const { event } = useEvent();

    const [searchValue, setSearchValue] = useState('');
    const [selectedValue, setSelectedValue] = useState('');
    const [syncPropertys, setSyncPropertys] = useState(true);
    const [searchClickable, setSearchClickable] = useState(null);
    const [searchTrigger, setSearchTrigger] = useState(0);
    const [toggleBackData, setToggleBackData] = useState(false)
    const [searchInputValue, setSearchInputValue] = useState('')
    const [refreshInput, setRefreshInput] = useState(false)

    function upCollapse() {
        setCollapse({
            ...collapse,
            height: END_HEIGHT,
            arrowPosition: 'both',
        })
        setSearchClickable(true)
    };

    function downCollapse() {
        setCollapse({
            ...collapse,
            height: INITIAL_HEIGHT,
            arrowPosition: true,
        })
    };

    function toggleCollapse() {
        if (toggleBackData) {
            setCollapse({
                ...collapse,
                height: INITIAL_HEIGHT,
                arrowPosition: true,
                withContent: false
            })
            return
        }

        collapse.arrowPosition === true ? upCollapse() : downCollapse();
    };

    // async function getAutocompleteData(word) {
    //     setSyncPropertys(false)
    //     setSearchValue(true)

    //     try {
    //         const { data } = await eventsApi.autocomplete(word);
    //         setSearchValue(data);
    //     } catch (error) {
    //         console.log(error);
    //     }
    // };

    // function onSelectAutocompleteItem(e) {
    //     setSearchValue(false);
    //     setSyncPropertys(true);
    //     setSelectedValue(e);
    // };

    function showEventSelected(event) {
        setCollapse({
            ...collapse,
            withContent: true,
            height: '95vh',
            arrowPosition: false,
            componentToRender: () => event && <EventDetail data={event} />
        })
    }

    function onBack(data) {
        setSearchInputValue('')
        setRefreshInput(Math.floor(Math.random() * 20000))
        setSearchClickable(true)
        setToggleBackData(true)
        setCollapse({
            ...collapse,
            withContent: true,
            height: '95vh',
            arrowPosition: 'both',
            componentToRender: () => data && boxCollapseContent(data)
        })
    }

    function onCloseCollapse() {
        setSearchTrigger(false)
        setToggleBackData(false)
        setSearchInputValue('')
        setRefreshInput(Math.floor(Math.random() * 20000))
        setEventFilter(false)
        randomNumber = false
        onClose()
    }

    function renderSelects(backData) {
        if (collapse.height === END_HEIGHT) {
            if (backData) {
                return <Selects
                    userLocation={userLocation}
                    backData={backData}
                    searchTrigger={randomNumber}
                />
            }

            return <Selects
                userLocation={userLocation}
                searchTrigger={searchTrigger}
                isRouteParam={isRouteParam}
            />
        }

        return <EventsNearToYou
            userLocation={userLocation}
            searchEvents={() => upCollapse()}
            wrap={collapse.height === END_HEIGHT}
            onEventClick={(event) => {
                showEventSelected(event)
                onNearToYouClick(event)
            }}
        />
    }


    function boxCollapseContent(backData) {
        return (
            <CollapseContainer>
                {
                    collapse.height === END_HEIGHT &&
                    <IconWrapper>
                        <IconContentClickable onClick={() => onClose()} width='100px'>
                            <IconContainer>
                                <Icon name='back' color={colors.night} />
                            </IconContainer>
                            <Text color={colors.night} marginTop='3px' type='bold'>Voltar</Text>
                        </IconContentClickable>
                    </IconWrapper>
                }
                <InputWithAutocomplete
                    placeholder='Busque por evento, endereço ou CEP'
                    id='filter_search_input'
                    // data={searchValue}
                    layout='roundedDark'
                    inputValue={searchInputValue}
                    badgeIcon='search'
                    badgeIconColor={colors.neutral}
                    isBadgeClickable={searchClickable}
                    trigger={refreshInput}
                    onBadgeClick={() => {
                        setRefreshInput(Math.floor(Math.random() * 20000))
                        setSearchInputValue('')
                        setSearchTrigger(searchTrigger + 1)

                        if (backData) {
                            randomNumber = Math.floor(Math.random() * 20000)
                        }
                    }}
                    badgeIconBackground='#4F86F7'
                    onChange={(e) => {
                        setSearchInputValue(e)
                        setEventFilter({ ...eventFilter, term: e })
                        setSearchValue(true)
                    }}
                    onFocus={() => !backData && upCollapse()}
                // onChange={(e) => getAutocompleteData(e)}
                // syncProp={syncPropertys}
                // debounce
                // onSelectItem={(e) => onSelectAutocompleteItem(e)}
                />

                {renderSelects(backData)}
            </CollapseContainer>
        )
    }

    return (
        <BoxCollapse
            height={collapse.height}
            arrowPosition={collapse.arrowPosition}
            upCollapse={() => upCollapse()}
            downCollapse={() => downCollapse()}
            onToggle={() => toggleCollapse()}
            onClose={() => onCloseCollapse()}
            onBack={(e) => onBack(e)}
        // isEdit={event?.owner}
        // isDelete={event?.owner}
        // onDelete={() => onDelete()}
        // onEdit={() => onEdit()}
        >
            {!collapse.withContent ? boxCollapseContent() : collapse.componentToRender()}
        </BoxCollapse>
    )
};


const CollapseContainer = styled(Column)`
    padding: ${sizes.none} ${sizes.medium};
    overflow-x: unset;
`;

const IconContainer = styled.div`
    width: 20px;
    height: 20px;
    margin-right: 10px;
    cursor: pointer;
`;

const IconWrapper = styled.div`
    justify-content: center;
    width: 100%;
    margin-bottom: 16px;
    height: 100%;
    display: none;

    @media screen and (min-width: ${breakpoints.lg}) {
        display: flex;
    }
`

const IconContentClickable = styled(Row)`
    cursor: pointer;
    width: auto;
`;